import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'libs/Form/components/Form';
import Loader from 'components/ui2/Loader';
import { InstitutionCard } from './institutioncard';

const FormInstitutionCardComponent = ({
  datiLogin,
  getInstitutionCard,
  hasErrors,
  initialDataset,
  institutionId,
  isAdmin,
  isLoading,
  validationSchema: creationSchema,
}) => {
  if (hasErrors) {
    return null;
  }

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      initialDataset={initialDataset}
      validationSchema={creationSchema(initialDataset)}
      validateOnBlur
      validateOnMount
    >
      <InstitutionCard
        isAdmin={isAdmin}
        datiLogin={datiLogin}
        institutionId={institutionId}
        getInstitutionCard={getInstitutionCard}
      />
    </Form>
  );
};

FormInstitutionCardComponent.displayName = 'Form institution card';

FormInstitutionCardComponent.propTypes = {
  datiLogin: PropTypes.shape({
    idCittadino: PropTypes.number,
    idEnte: PropTypes.number,
    nome: PropTypes.string,
    ruolo: PropTypes.string,
  }).isRequired,
  getInstitutionCard: PropTypes.func.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  initialDataset: PropTypes.shape({}).isRequired, // Specifica se conosci le chiavi
  institutionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAdmin: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  validationSchema: PropTypes.func.isRequired,
};

export const FormInstitutionCard = FormInstitutionCardComponent;
